import { useMutation } from '@apollo/client';
import React, { useCallback, useContext } from 'react';
import Mutation from './MessageListDeleteMutation.gql';
import {
  MessageListDelete as IData,
  MessageListDeleteVariables as IVariables,
} from './_QueryTypes/MessageListDelete';
import { ActiveDatabaseContext } from '../../ActiveDatabaseContext/ActiveDatabaseContext';
import MessageListQuery from '../Querys/MessageListQuery.gql';
import { remove, findIndex, propEq, assocPath } from 'ramda';
import { LoginStateContext } from '../../../Features/Login/Contexts/LoginStateContext/LoginStateContext';
import { getMessageListSelection } from '../Querys/MessageListQuery';

interface IProps {
  children: (deleteMessages: MessageDeleteType) => React.ReactNode;
}
export type MessageDeleteType = (variables: IVariables) => void;

const MessageListDeleteMutation: React.FC<IProps> = props => {
  const { sign } = React.useContext(LoginStateContext);
  const activeDatabase = useContext(ActiveDatabaseContext).activeDatabase;
  const [deleteFunction] = useMutation<IData, IVariables>(Mutation);
  const deleteMessages: MessageDeleteType = useCallback(
    variables => {
      deleteFunction({
        variables: variables,
        optimisticResponse: {
          rtn: {
            SYSMessageDelete: null,
            __typename: 'TEDAvenyRoutineMutation',
          },
        },
        update: proxy => {
          const selection = getMessageListSelection(sign);
          // Read cache to get list of items
          const data: any = proxy.readQuery({
            query: MessageListQuery,
            variables: {
              databaseName: activeDatabase || '',
              selection,
            },
          });
          // remove item
          const updatedMeddelandeList = remove(
            findIndex(
              propEq('id', variables.id),
              data.db.SYSMeddelandeTill_All
            ),
            1,
            data.db.SYSMeddelandeTill_All
          );

          const updatedData = assocPath(
            ['db', 'SYSMeddelandeTill_All'],
            updatedMeddelandeList,
            data
          );
          // Write updated list to cache
          proxy.writeQuery({
            query: MessageListQuery,
            variables: {
              databaseName: activeDatabase || '',
              selection,
            },
            data: updatedData,
          });
        },
      });
    },
    [activeDatabase, deleteFunction, sign]
  );
  return <>{props.children(deleteMessages)}</>;
};

export default MessageListDeleteMutation;
